/* tslint:disable */
/* eslint-disable */
export enum Ethnicity {
  Maori = 'M\u0101ori',
  NzEuropean = 'NzEuropean',
  Samoan = 'Samoan',
  Niuean = 'Niuean',
  CookIslander = 'CookIslander',
  Fijian = 'Fijian',
  Tongan = 'Tongan',
  Indian = 'Indian',
  Chinese = 'Chinese',
  Other = 'Other'
}
